module.exports = __webpack_public_path__ + "static/img/la-3.e3c714d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/ComicDetail/img/link-active/la-3.png
// module id = 170
// module chunks = 0